export const Props = () => ({
  //Плеер проигрывается?
  isPlaying: {
    type: Boolean,
  },

  //Модификатор увеличения кнопок
  scale: {
    type: Number,
    default: 1,
  },

  //Отобразить лоадер вместо иконки?
  isLoading: { type: Boolean },

  //Цвет svg иконок
  color: { type: String },

  //Скорость проигрывания
  speed: { type: Number }
});